import LoginForm from "../../components/Forms/LoginForm";
import { Fragment } from "react";

const Login = () => {
    return ( 
        <Fragment>
            <LoginForm />
        </Fragment>
        );
}
 
export default Login;